/**
 * Sends a GA4 page_view for client-side route changes (gtag must already be in index.html).
 * Uses an explicit page_view event so SPA gallery navigation (slug changes) is recorded reliably.
 */
export function trackGoogleAnalyticsPageView(
  measurementId,
  { pagePath, pageTitle } = {}
) {
  if (!measurementId || typeof window === "undefined" || !window.gtag) return;

  const path = pagePath || window.location.pathname;
  const title = pageTitle || document.title;
  const location =
    window.location.origin + path + window.location.search + window.location.hash;

  window.gtag("config", measurementId, {
    page_path: path,
    page_title: title,
  });

  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title,
    page_location: location,
  });
}
